import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-departmentManagement",
  "use": "icon-departmentManagement-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-departmentManagement\"><path d=\"M625.777778 0a113.777778 113.777778 0 0 1 113.777778 113.777778v796.444444a113.777778 113.777778 0 0 1-113.777778 113.777778H113.777778a113.777778 113.777778 0 0 1-113.777778-113.777778V113.777778a113.777778 113.777778 0 0 1 113.777778-113.777778h512z m284.444444 0a113.777778 113.777778 0 0 1 113.777778 113.777778v782.848a113.777778 113.777778 0 1 1-227.555556 0V113.777778a113.777778 113.777778 0 0 1 113.777778-113.777778zM511.772444 424.277333h-284.444444a56.888889 56.888889 0 1 0 0 113.777778h284.444444a56.888889 56.888889 0 1 0 0-113.777778z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/departmentManagement.svg
// module id = ePPX
// module chunks = 78